import React, { useEffect, useState } from "react";
import axios from "axios";
import "../admin.css";
import { NavLink } from "react-router-dom";

const UserList = () => {
  let [loggedinuser] = useState(JSON.parse(localStorage.getItem("user")));
  const [users, setUsers] = useState([]);
  const [pages, setPages] = useState({ page: 1, size: 100 });
  const [paging, setPaging] = useState(true);

  const filterFunction = () => {
    // Declare variables
    var input, filter, table, tr, td,td1, i, txtValue;
    input = document.getElementById("myInput");
    filter = input.value.toUpperCase();
    table = document.getElementById("myTable");
    tr = table.getElementsByTagName("tr");

    // Loop through all table rows, and hide those who don't match the search query
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[0];
      td1 = tr[i].getElementsByTagName("td")[1];
      if (td || td1) {
        txtValue =
          (td.textContent || td.innerText) + (td1.textContent || td1.innerText);

        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
      
    }
  };

  const nextPage = () => {
    loadPaging(pages.page + 1, pages.size);
    setPages((prevState) => {
      return {
        ...prevState,
        page: prevState.page + 1,
      };
    });
  };

  const loadPaging = async (page, size = pages.size) => {
    try {

      // await axios
      //   .get(
      //     'http://localhost:4200/21030235'
      //   )
      //   .then((response) => {
      //     console.log(response);
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });


      await axios
        .get(
          localStorage.getItem("basurl") +
            "/users?page=" +
            page +
            "&size=" +
            size,
          {
            headers: {
              "mojo-access-tokens": loggedinuser.token,
            },
          }
        )
        .then((response) => {
          setUsers((prevState) => {
            prevState.push.apply(prevState, response.data);
            return [...prevState];
          });
          if (response.data.length < size) {
            setPaging(false);
          }
        })
        .catch((error) => {
          if (
            typeof error.response.data !== undefined &&
            error.response.data.loginRequired
          ) {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadPaging(1);
  }, []);

  return (
    <>
      <input
        type="text"
        id="myInput"
        onKeyUp={filterFunction}
        placeholder="Search for names.."
      ></input>
      {users.length ? (
        <table id="myTable" className="table table-striped table-hover">
          <thead>
            <tr>
              <th>Name</th>
              <th>Location</th>
              <th>Role</th>
              <th>Mobile</th>
              <th>Mail-id</th>
              <th>Admin</th>
              <th>Active</th>
              <th>Deleted</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {users.map((item) => (
              <tr key={item.id}>
                <td>
                  {item.firstname} {item.lastname}
                </td>
                <td>
                  {item.city} ({item.stateshortname})
                </td>
                <td>{item.role}</td>
                <td>{item.mobile_number}</td>
                <td>{item.emailid}</td>
                <td>
                  <input type="checkbox" disabled checked={item.is_admin} />
                </td>
                <td>
                  <input type="checkbox" disabled checked={item.status} />
                </td>
                <td>
                  <input type="checkbox" disabled checked={item.is_deleted} />
                </td>
                <td>
                  <NavLink
                    to={`/admin/update-user/${item.id}`}
                    className="mg-l-10"
                  >
                    Edit
                  </NavLink>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="media pd-20 pd-xs-30">
          <span className="tx-center">You have not added any user yet.</span>
        </div>
      )}
      <div className="card-footer tx-10 pd-y-15 bg-transparent tx-center">
        {paging ? (
          <h4 onClick={nextPage} href="#" className="pointer tx-16">
            <i className="fa fa-angle-down mg-r-5" />
            View More
          </h4>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default UserList;
